import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

interface OutlookTextStore {
  text: string;

  setText: (newText: string) => void;
}

const useOutlookTextStore = createWithEqualityFn<OutlookTextStore>((set) => ({
  text: '',

  setText(newText: string) {
    set(() => ({ text: newText }));
  },
}), shallow);

export default useOutlookTextStore;
